import { render, staticRenderFns } from "./PatientCoachingSummaryMindset.vue?vue&type=template&id=901472dc"
import script from "./PatientCoachingSummaryMindset.vue?vue&type=script&lang=js"
export * from "./PatientCoachingSummaryMindset.vue?vue&type=script&lang=js"
import style0 from "./PatientCoachingSummaryMindset.vue?vue&type=style&index=0&id=901472dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports